<template>
     <modal class="new-modal-default small-modal" transition="nice-modal-fade create-configure" :name="modal_name" :delay="100"
          :width="200" height="auto" :adaptive="true" :scrollable="true" :clickToClose="false">
          <div class="v-modal-content" style="background-color: #ffffff !important;">
               <div class="v-modal-header-new">
                    <div></div>
                    <div>
                         <span v-if="qr_code_type == 'view'"
                              class="v-modal-dialog-title-new v-modal-title text-white">View QR Code</span>
                         <span class="v-modal-dialog-title-new v-modal-title text-white fs-20">Print QR Code</span>
                         <!-- v-if="qr_code_type == 'print'" -->
                         <span v-if="qr_code_type == 'print_all'"
                              class="v-modal-dialog-title v-modal-title text-white">Print All QR Code</span>
                    </div>
                    <!-- <div>
                         <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideModal"></span>
                    </div> -->
               </div>
               <div class="mb-3">
                    <div>
                         <span class="fs-12 text-secondary ml-5">QR Code Info </span>
                    </div>
               </div>
               <div class="v-modal-body-new scroll-new pt-2 pb-1 m-4"
                    style="border: 0.5px solid #0d84f2; border-radius: 6px; width:auto !important;" id="printId">
                    <div class="v-modal-layout">
                         <div class="d-flex justify-content-center align-items-center">
                              <div class="bg-white p-5 bord-rad-5px">
                                   <p class="my-3 qr-code text-center text-black">{{qr_code_name}}</p>
                                   <div class="d-flex justify-content-center qr-code-img-mob-responsive">
                                        <!-- <p :title="qr_cde" class="text-center text-black fw-500 my-2" style="max-width: 150px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{qr_cde.location}}</p> -->
                                        <!-- <img src="/images/images-new/menu/QrCode_img.png" width="200" alt=""> -->
                                        <qr-code :text="qr_cde" 
                                             :size="150"
                                             color="#0d84f2">
                                        </qr-code>
                                   </div>
                                   
                              </div>
                         </div>
                    </div>
               </div>
               <div class="v-modal-dialog-actions-new">
                    <div class="d-flex justify-content-end align-items-center">
                         <button class="btn btn-danger-new text-capitalize" @click="hideModal()">
                              Close
                         </button>
                         <button class="btn text-capitalize ml-3 fw-500"
                              style="background-color: #00448b!important;border-radius: 5px !important; color: white;"
                              @click="printWeb()">
                              <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/printer.svg" class="w-18">
                              Print
                         </button>
                    </div>
               </div>
          </div>
     </modal>
</template>

<script>
     import VueQRCodeComponent from 'vue-qr-generator'
     import print from '../../mixins/print'
     export default {
          props: ['modal_name', 'qr_cde', 'qr_code_type', 'qr_code_name'],
          mixins: [print],
          data() {
               return {

               }
          },
          methods: {
               hideModal() {
                    this.$emit('hide-view-qr-code')
               }
          },
          components: {
               VueQRCodeComponent
          }
     }
</script>

<style scoped>
     .btn-print {
          border-radius: 18px !important;
          background: #ab33ea;
          color: #fff;
     }

     .qr-code {
          font-weight: 500;
          color: #005dae;
          font-size: 14;
     }

     .bg-white {
          background: #fff;
     }

     .bg-light-sky-blue {
          background: #cce3fc;
     }

     .bord-rad-5px {
          border-radius: 5px;
     }

     .inner-line-hr {
          border: 0;
          width: 100%;
          border-top: 2px solid #a5a5a5;
     }

     .v-modal-dialog-actions-new {
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: center;
          -webkit-justify-content: center;
          -ms-flex-pack: center;
          justify-content: flex-end;
          padding: 15px;
          border-top: 0px solid transparent;
     }

     .v-modal-header-new {
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: start;
          -webkit-align-items: flex-start;
          -ms-flex-align: start;
          align-items: flex-start;
          -webkit-box-pack: justify;
          -webkit-justify-content: space-between;
          -ms-flex-pack: justify;
          justify-content: flex-start;
          padding-left: 15px;
          padding-top: 15px;
          border-bottom: 0px solid #E9ECEF;
          -webkit-border-top-left-radius: 15px;
          border-top-left-radius: 15px;
          -webkit-border-top-right-radius: 15px;
          border-top-right-radius: 15px;
          background-color: white !important;
     }

     .v-modal-dialog-title-new {
          margin-bottom: 0px !important;
          font-size: 20px !important;
          font-weight: 600 !important;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          color: #00448b !important;
          padding: 4px !important;
     }

     .v-modal-body-new {
          width: 100%;
          position: relative;
          -webkit-box-flex: 1;
          -webkit-flex: 1 1 auto;
          -ms-flex: 1 1 auto;
          flex: 1 1 auto;
          padding: 15px;
     }
</style>